import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../users/shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MassCommMessageAdminAnalyticsComponent } from './mass-comm-message-admin-analytics/mass-comm-message-admin-analytics.component';
import { TabComponent, TabsComponent } from 'src/app/shared/widgets/tabs';

/**
 * admin mass comm messages
 */
@Component({
  selector: 'wl-mass-comm-message-admin',
  templateUrl: 'mass-comm-message-admin.component.html',
  styleUrls: [],
  providers: [],
    standalone: false
})
export class MassCommMessageAdminComponent implements OnInit, AfterViewInit {
  @ViewChild(MassCommMessageAdminAnalyticsComponent) private _analyticsDashboard: MassCommMessageAdminAnalyticsComponent;
  startDate: Date;
  endDate: Date;
  showDateFilter: boolean = false;
  @ViewChild('tabsContainer', { static: false }) public tabsContainer: TabsComponent;
  @ViewChild('draftsTab') public draftsTab: TabComponent;
  @ViewChild('recurringTab') public recurringTab: TabComponent;
  @ViewChild('scheduledTab') public scheduledTab: TabComponent;
  @ViewChild('sentTab') public sentTab: TabComponent;

  /**
   * inject
   * @param _userService
   * @param _router
   */
  public constructor(private _route: ActivatedRoute, private _userService: UserService, private _router: Router) {}

  /**
   * on init
   */
  public ngOnInit(): void {
    // make sure they should be here
    this._userService.getCurrentUserSecurityElementAccessLevel('Send_Mass_Communicatons').then((userAccessLevel: number) => {
      if (userAccessLevel < 2) this._router.navigate(['access/denied']);
    });
    this.startDate = new Date();
    this.endDate = new Date();
    this.startDate.setMonth(this.startDate.getMonth() - 3);
  }

  public ngAfterViewInit(): void {
    this._route.children?.forEach((childRoute) => {
      const urlPath = childRoute.snapshot.url[0]?.path?.toLowerCase();
      let targetTab: TabComponent;

      switch (urlPath) {
        case 'analytics':
          break;
        case 'drafts':
          targetTab = this.draftsTab;
          break;
        case 'recurring':
          targetTab = this.recurringTab;
          break;
        case 'scheduled':
          targetTab = this.scheduledTab;
          break;
        case 'sent':
          targetTab = this.sentTab;
          break;
      }

      if (targetTab) {
        setTimeout(() => this.tabsContainer.select(targetTab), 0);
      }
    });
  }
}
